import React from 'react';
import { Music, Download } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const FreeBonusSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 md:py-24 bg-[#1a1f2e]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div 
          className="relative rounded-2xl overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, #8B6914 0%, #A67C00 25%, #C4941A 50%, #A67C00 75%, #8B6914 100%)'
          }}
        >
          {/* Overlay for depth */}
          <div className="absolute inset-0 bg-gradient-to-br from-black/20 to-transparent" />
          
          <div className="relative z-10 p-8 md:p-16 text-center">
            {/* Music Icon */}
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                <Music className="w-8 h-8 text-white" />
              </div>
            </div>

            {/* Title */}
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              {t('freeBonus')}
            </h2>

            {/* Description */}
            <p className="text-white/90 text-lg max-w-2xl mx-auto mb-8">
              {t('freeBonusDesc')}
            </p>

            {/* CTA Button */}
            <button className="inline-flex items-center gap-3 bg-white text-[#8B6914] px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-300 shadow-lg">
              <Download className="w-5 h-5" />
              {t('downloadBonus')}
            </button>

            {/* Value Tag */}
            <p className="text-white/70 text-sm mt-6 uppercase tracking-wider">
              {t('bonusValue')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeBonusSection;
